"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/OpenFileFallbackModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Form = require('web/components/Form');
var _Button = require('web/components/Form/Button/Button');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);











const OpenFileFallbackModal = ({ fallback, onClose, onDownload }) => {
  const handleDownload = _react.useCallback.call(void 0, () => {
    onClose()
    _optionalChain([onDownload, 'optionalCall', _ => _()])
  }, [onClose, onDownload])

  if (!fallback) return null

  const offersDownload = fallback.status === 'ready' && !!onDownload

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: true,
      onClose: onClose,
      title: offersDownload ? 'Download file' : 'Open file',
      size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}

      , fallback.status === 'ready'
        ? _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
            , offersDownload
              ? "This file can't be previewed here."
              : 'The file did not open automatically. Use the button below to open it.'
          )
          , _react2.default.createElement('div', { className: "blm-modal--buttons-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
            , _react2.default.createElement('a', {
              href: fallback.url,
              target: "_blank",
              rel: "noopener noreferrer" ,
              className: _classBuilder2.default.call(void 0, _Button.btnClassName, offersDownload ? _Button.secondaryBtnClassName : 'blm-btn--primary'),
              onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}

              , offersDownload ? 'Open' : 'Open file'
            )
            , offersDownload && _react2.default.createElement(_Form.Button, { onClick: handleDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}, "Download")
          )
        )
        : _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, "We could not open this file. Please try again."

          )
          , _react2.default.createElement(_Modal.ModalControls, {
            primaryBtnLabel: "Close",
            onPrimaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
          )
        )
    )
  )
}

exports. default = OpenFileFallbackModal
